<template>
    <div>
        <div class="title-text">粉丝列表</div>
        <el-table :data="fansList" style="width: 100%; margin: 10px 0;" size="medium"
                  :header-cell-style="{fontWeight: 'normal', height: '46px', color: '#5F5C74'}"
                  :cell-style="{fontSize: '14px',color: '#16113F'}">
            <el-table-column align="left" label="头像/用户名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="person-info">
                        <div class="avatar-box">
                            <img :src="scope.row.avatar ? scope.row.avatar : require('../../assets/img/image/user_img.png')" alt="">
                        </div>
                        <div class="text-overflow name">{{scope.row.nickname}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="性别" :resizable="false" width="120">
               <template slot-scope="scope">
                    <div class="gender" v-if="scope.row.gender === 0">未公开</div>
                   <div class="gender" v-if="scope.row.gender === 1">男</div>
                   <div class="gender" v-if="scope.row.gender === 2">女</div>
               </template>
           </el-table-column>
           <el-table-column prop="province" align="center" label="省份" :resizable="false">
               <template slot-scope="scope">
                   <div class="gender" v-if="scope.row.province">{{scope.row.province}}</div>
                   <div class="gender" v-else >-</div>
               </template>
           </el-table-column>
           <el-table-column prop="city" align="center" label="城市" :resizable="false">
               <template slot-scope="scope">
                   <div class="gender" v-if="scope.row.city">{{scope.row.city}}</div>
                   <div class="gender" v-else >-</div>
               </template>
           </el-table-column>
           <el-table-column prop="country" align="center" label="国家" :resizable="false" >
               <template slot-scope="scope">
                   <div class="gender" v-if="scope.row.country">{{scope.row.country}}</div>
                   <div class="gender" v-else >-</div>
               </template>
           </el-table-column>
            <!-- <el-table-column prop="signature" align="center" label="签名"></el-table-column>
            <el-table-column prop="score" align="center" label="互动分" width="120"></el-table-column> -->
        </el-table>
        <!-- <div style="text-align: center; cursor: pointer" v-if="hasMore" @click="moreBtn">查看更多</div> -->
<!--        <div style="text-align: center" v-else>暂时没有更多了</div>-->
<el-pagination
                class="pages-center" style="padding-bottom: 10px;"
                :current-page="attentionPages.currentPageNum"
                :page-size="attentionPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="attentionPages.total"
                @current-change="attentionCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                fansList: [],
                hasMore: false,
                cursor: 0,
                attentionPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
            }
        },
        created() {
            // this.getFansList()
        },
        methods: {
            // 获取粉丝列表
            getFansList() {
                let params = {
                    account_id: Number(this.$route.query.id) || '',
                    page:this.attentionPages.currentPageNum,
                    limit:this.attentionPages.eachPageNum,
                }
                this.$httpStudent.axiosGetBy(this.$api.tiktokInteractionFans, params, (res) => {
                    if (res.code === 200) {
                        console.log("res", res.data)
                        this.fansList = [...res.data.list]
                        this.attentionPages.total=res.data.total
                    } else {
                        this.$message.warning(res.message)
                        // setTimeout(()=>{
                        //     window.open(res.data.url, '抖音授权扫码', 'channelmode=0,directories=0,width=1000,height=500,top=200,left=200');
                        // },1000)
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            // 查看更多
            moreBtn() {
                this.getFansList()
            },
            attentionCurrentChange(val){
                this.attentionPages.currentPageNum=val
                this.getFansList()
            }
        }
    }
</script>

<style scoped lang="scss">
    .title-text {
        color: #16113F;
        font-size: 16px;
    }
    .person-info {
        display: flex;
        align-items: center;
        .avatar-box {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            overflow: hidden;
            background: #F1F0FE;
            flex-shrink: 0;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .name {
            margin-left: 10px;
            width: calc(100% - 48px);
            min-width: 120px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }
</style>
